export function removeFilterPrefix(value: string, prefix: string) {
	if (!value) {
		return undefined;
	}

	return value.replace(`${prefix}_`, '');
}
